import { render, staticRenderFns } from "./JLggz.vue?vue&type=template&id=4fa298c0&scoped=true"
import script from "./JLggz.vue?vue&type=script&lang=js"
export * from "./JLggz.vue?vue&type=script&lang=js"
import style0 from "./JLggz.vue?vue&type=style&index=0&id=4fa298c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa298c0",
  null
  
)

export default component.exports